module.exports = __webpack_public_path__ + "assets/assets/images/icons/login.bc55311d.svg";


//////////////////
// WEBPACK FOOTER
// ./client/assets/images/icons/login.svg
// module id = 276
// module chunks = 2